<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0 mt-4">
                <v-autocomplete
                        v-model="finalFolder"
                        dense
                        :items="folders"
                        outlined
                        item-text="name"
                        item-value="fid"
                        return-object
                        small-chips
                        deletable-chips
                        label="Target Folder">
                </v-autocomplete>
            </v-card-actions>
            <v-card-actions class="py-0 mb-6">
                <v-progress-linear
                        color="blue"
                        height="20"
                        :value="uploadProgress"
                        striped>
                </v-progress-linear>
            </v-card-actions>
            <v-card-actions class="mt-n5">
                <v-spacer></v-spacer>
                <v-btn :disabled="!btnEnabled"
                       class="ma-2"
                       color="primary"
                       @click="onPressMove">UPLOAD
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import {MultipleSnapshotsUploader} from "@/modules/mprofiles/utils/MultipleSnapshotsUploader";
import {UuidUtils} from "@/common/UuidUtils";

export default {
    name: "popup-upload-snapshots",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        uploadProgress: 0,
        finalFolder: null,
        uploader: null,
        shapshots: [],
        btnEnabled: true,
    }),
    computed: {
        folders(){
            return UsersBackendUtils.getFolders();
        }
    },
    methods: {
        show(data) {

            this.dialog = true
            this.uploadProgress = 0
            this.shapshots = []
            this.btnEnabled = false

            let zipper = require("jszip");
            let self = this;
            zipper.loadAsync(data).then(function(zip) {
                var count = 0;
                var keys = Object.keys(zip.files);
                keys.forEach(function (filename) {
                    zip.files[filename].async('string').then(function (fileData) {
                        count += 1;
                        self.shapshots.push({"id": UuidUtils.generate(), "data":JSON.parse(fileData)});
                        if (count == keys.length){
                            console.log("all ready")
                            self.btnEnabled = true;
                        }
                    })
                })
            });
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressMove() {
            if (this.shapshots.length == 0){
                this.$notify({title: 'Empty shapshots list!', type: "error"});
                return;
            }
            if (this.finalFolder == null){
                this.$notify({title: 'Please select target folder!', type: "error"});
                return;
            }
            var self = this;
            this.btnEnabled = false;
            this.uploader = new MultipleSnapshotsUploader(this.shapshots, this.finalFolder.fid);
            this.uploader.init();
            this.uploader.setOnProgress(function (progress){
                self.uploadProgress = progress * 100;
            });
            this.uploader.setOnComplete(function (status){
                console.log("complete: ", status)
                self.uploadProgress = 100;
                self.hide();
            });
        },
    },
}
</script>

<style scoped>

</style>